import type { TriyoProject, TriyoProjectMember, TriyoUser } from "@/types/models";

function memberUserId(member: TriyoProjectMember): number | undefined {
  return member.UserId ?? member.User?.UserId ?? member.User?.Id;
}

function groupContainsUser(members: { UserId?: number; Id?: number }[] | undefined, userId: number): boolean {
  return members?.some((member) => (member.UserId ?? member.Id) === userId) ?? false;
}

function isSuperAdmin(user: TriyoUser): boolean {
  if (user.IsSuperAdminRole === true || user.SuperAdmin === true) return true;
  if (user.Role?.SuperAdmin !== true) return false;
  return user.Company?.IsSuperAdmin !== false;
}

/**
 * Mirrors Triyo.Web's canEditProject relationship test. Role privileges are
 * deliberately checked by the caller so this function is reusable for both
 * Detail and Edit actions.
 */
export function hasDealRelationship(project: TriyoProject, user: TriyoUser | null | undefined): boolean {
  const userId = user?.Id;
  if (!user || !userId) return false;

  const isDirectMember = project.Members?.some((member) => !member.IsGroup && memberUserId(member) === userId) ?? false;
  const isGroupMember = project.Groups?.some((group) => groupContainsUser(group.Group?.Members, userId)) ?? false;
  const isLegacyGroupMember =
    project.Members?.some((member) => member.IsGroup === true && groupContainsUser(member.Group?.Members, userId)) ??
    false;

  if (project.CreatedById === userId || isSuperAdmin(user) || isDirectMember || isGroupMember || isLegacyGroupMember) {
    return true;
  }

  return project.IsMultiOwner !== true && project.OwnerId === userId;
}
